import { formatDateShort, formatPct, pctChipClass } from '@/components/AnalogLensAccordion';

type Props = {
  date: string;
  moveHeader?: string | null;
  executiveSummary: string;
  percentChange?: number | null;
  loading?: boolean;
  className?: string;
};

export function TodayMoveSummaryCard({
  date,
  moveHeader,
  executiveSummary,
  percentChange,
  loading = false,
  className = '',
}: Props) {
  if (loading) {
    return (
      <div
        className={`rounded-2xl border border-gray-200 bg-white p-5 animate-pulse ${className}`}
        aria-busy="true"
        aria-label="Loading today's move summary"
      >
        <div className="mb-3 h-3 w-32 rounded bg-gray-200" />
        <div className="mb-2 h-5 w-2/3 rounded bg-gray-200" />
        <div className="space-y-2">
          <div className="h-3 w-full rounded bg-gray-100" />
          <div className="h-3 w-full rounded bg-gray-100" />
          <div className="h-3 w-11/12 rounded bg-gray-100" />
        </div>
      </div>
    );
  }

  if (!executiveSummary.trim()) return null;

  return (
    <section
      className={`rounded-2xl border border-gray-200 bg-white p-5 ${className}`}
      aria-label={`Why the stock moved on ${formatDateShort(date)}`}
    >
      <div className="mb-2 flex flex-wrap items-center gap-x-3 gap-y-1">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">
          Why it moved · {formatDateShort(date)}
        </p>
        {percentChange != null && Number.isFinite(percentChange) ? (
          <span className={`text-sm font-medium tabular-nums ${pctChipClass(percentChange)}`}>
            {formatPct(percentChange)}
          </span>
        ) : null}
      </div>
      {moveHeader?.trim() ? (
        <h2 className="mb-2 text-base font-medium text-gray-800">{moveHeader.trim()}</h2>
      ) : null}
      <p className="text-sm leading-relaxed text-gray-600">{executiveSummary.trim()}</p>
    </section>
  );
}
